module.exports = __webpack_public_path__ + "img/asus-zenfone5-selfie.d9372dc0.jpg";